import { __extends, __spread } from 'tslib';
import { cloneElement, createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Component, Input, Output, ViewChild, ViewContainerRef, ElementRef, EventEmitter, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/common-constants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SharedComponentLoaderCustomEvents = /** @class */ (function () {
    function SharedComponentLoaderCustomEvents() {
    }
    /**
     * \@description This event will be broadcasted when Shared Component is loaded completely.
     */
    SharedComponentLoaderCustomEvents.SharedComponentLoadComplete = "SharedComponentLoadComplete";
    /**
     * \@description This event will be broadcasted when Shared Component update because of input or output value change.
     */
    SharedComponentLoaderCustomEvents.SharedComponentLoaderUpdated = "SharedComponentLoaderUpdated";
    /**
     * \@description This event will be broadcasted when the callback method of Shared Component is invoked.
     */
    SharedComponentLoaderCustomEvents.SharedComponentCallBackInvoked = "SharedComponentCallBackInvoked";
    /**
     * \@description SharedComponentCallBackInvoked
     */
    SharedComponentLoaderCustomEvents.SharedComponentOnDestroyInvoked = "SharedComponentOnDestroyInvoked";
    return SharedComponentLoaderCustomEvents;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-rendering-manager.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *  AngularComponentLibraries
 */
/**
 * Abstract class for managing the lifecycle of shared components.
 * ComponentRenderingManager
 * Class responsibile for rendering and managing the life-cycle of Shared Components.
 * @abstract
 */
var  /**
 * Abstract class for managing the lifecycle of shared components.
 * ComponentRenderingManager
 * Class responsibile for rendering and managing the life-cycle of Shared Components.
 * @abstract
 */
ComponentRenderingManager = /** @class */ (function () {
    /**
     * constructor
     * Parameter {inputParameters} - json object which contains properties needed by the shared component.
     * Parameter {eventNamesToSubscribe} List of event names needs to be subscribed for call backs. It supports coma-spearated values or array of strings.
     * Parameter {renderingContainer} Container in which the component needs to be rendered.
     */
    function ComponentRenderingManager(inputParameters, eventNamesToSubscribe, renderingContainer, componentReference, onComponentEvent) {
        this.inputParameters = inputParameters;
        this.eventNamesToSubscribe = eventNamesToSubscribe;
        this.renderingContainer = renderingContainer;
        this.componentReference = componentReference;
        this.onComponentEvent = onComponentEvent;
    }
    /**
     * onDestroy Unmount the shared component.
     */
    /**
     * onDestroy Unmount the shared component.
     * @return {?}
     */
    ComponentRenderingManager.prototype.onDestroy = /**
     * onDestroy Unmount the shared component.
     * @return {?}
     */
    function () {
        this._childComponentRef = null;
    };
    /**
     * onComponentInputChange Handles the events/callbacks from Shared Component controls.
     */
    /**
     * onComponentInputChange Handles the events/callbacks from Shared Component controls.
     * @param {?} eventName
     * @param {?} args
     * @return {?}
     */
    ComponentRenderingManager.prototype.onCallbackFromComponent = /**
     * onComponentInputChange Handles the events/callbacks from Shared Component controls.
     * @param {?} eventName
     * @param {?} args
     * @return {?}
     */
    function (eventName, args) {
        /** @type {?} */
        var payload = {
            eventName: eventName,
            data: args
        };
        this.onComponentEvent(payload);
    };
    return ComponentRenderingManager;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ReactComponentRenderingManager.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ReactComponentRenderingManager = /** @class */ (function (_super) {
    __extends(ReactComponentRenderingManager, _super);
    function ReactComponentRenderingManager(inputParameters, eventNamesToSubscribe, renderingContainer, componentReference, onComponentEvent) {
        var _this = _super.call(this, inputParameters, eventNamesToSubscribe, renderingContainer, componentReference, onComponentEvent) || this;
        _this.inputParameters = inputParameters;
        _this.eventNamesToSubscribe = eventNamesToSubscribe;
        _this.renderingContainer = renderingContainer;
        _this.componentReference = componentReference;
        _this.onComponentEvent = onComponentEvent;
        return _this;
    }
    /**
     * @return {?}
     */
    ReactComponentRenderingManager.prototype.renderComponent = /**
     * @return {?}
     */
    function () {
        this.render(false);
    };
    /**
     * @return {?}
     */
    ReactComponentRenderingManager.prototype.onComponentInputChange = /**
     * @return {?}
     */
    function () {
        this.render(true);
    };
    /**
     * @param {?=} isRerender
     * @return {?}
     */
    ReactComponentRenderingManager.prototype.render = /**
     * @param {?=} isRerender
     * @return {?}
     */
    function (isRerender) {
        if (isRerender === void 0) { isRerender = false; }
        /** @type {?} */
        var self = this;
        /** @type {?} */
        var container = this.renderingContainer.nativeElement;
        /** @type {?} */
        var props = {};
        // Set Input Parameters
        if (this.inputParameters) {
            Object.keys(this.inputParameters).forEach((/**
             * @param {?} propName
             * @return {?}
             */
            function (propName) {
                props[propName] = self.inputParameters[propName];
            }));
        }
        // Subscribe for Output Parameters
        if (this.eventNamesToSubscribe && this.eventNamesToSubscribe.length > 0) {
            this.eventNamesToSubscribe.forEach((/**
             * @param {?} eventName
             * @return {?}
             */
            function (eventName) {
                props[eventName] = (/**
                 * @param {?} e
                 * @return {?}
                 */
                function (e) {
                    self.onCallbackFromComponent.call(self, eventName, __spread(arguments));
                });
            }));
        }
        if (isRerender && this._childComponentRef) {
            this._childComponentRef = cloneElement(this._childComponentRef, props, null);
        }
        else {
            this._childComponentRef = createElement(this.componentReference, props, null);
        }
        render(this._childComponentRef, container);
    };
    /**
     * @return {?}
     */
    ReactComponentRenderingManager.prototype.onDestroy = /**
     * @return {?}
     */
    function () {
        unmountComponentAtNode(this.renderingContainer.nativeElement);
        _super.prototype.onDestroy.call(this);
    };
    return ReactComponentRenderingManager;
}(ComponentRenderingManager));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/AngularComponentRenderingManager.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AngularComponentRenderingManager = /** @class */ (function (_super) {
    __extends(AngularComponentRenderingManager, _super);
    function AngularComponentRenderingManager(inputParameters, eventNamesToSubscribe, renderingContainer, componentReference, onComponentEvent) {
        var _this = _super.call(this, inputParameters, eventNamesToSubscribe, renderingContainer, componentReference, onComponentEvent) || this;
        _this.inputParameters = inputParameters;
        _this.eventNamesToSubscribe = eventNamesToSubscribe;
        _this.renderingContainer = renderingContainer;
        _this.componentReference = componentReference;
        _this.onComponentEvent = onComponentEvent;
        _this._subscriptionRef = [];
        return _this;
    }
    /**
     * @return {?}
     */
    AngularComponentRenderingManager.prototype.renderComponent = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var container = (/** @type {?} */ (this.renderingContainer));
        this._childComponentRef = container.createComponent(this.componentReference);
        this.updateInputParameters();
        this.subscribeOuputParameterEvents();
    };
    /**
     * @return {?}
     */
    AngularComponentRenderingManager.prototype.onComponentInputChange = /**
     * @return {?}
     */
    function () {
        this.updateInputParameters();
    };
    /**
     * @return {?}
     */
    AngularComponentRenderingManager.prototype.updateInputParameters = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var self = this;
        if (!this._childComponentRef)
            return;
        if (this.inputParameters) {
            Object.keys(this.inputParameters).forEach((/**
             * @param {?} propName
             * @return {?}
             */
            function (propName) {
                self._childComponentRef.instance[propName] = self.inputParameters[propName];
            }));
        }
    };
    /**
     * @return {?}
     */
    AngularComponentRenderingManager.prototype.clearComponentEventSubscriptions = /**
     * @return {?}
     */
    function () {
        this._subscriptionRef.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        function (subscription) { return subscription.unsubscribe(); }));
    };
    /**
     * @return {?}
     */
    AngularComponentRenderingManager.prototype.subscribeOuputParameterEvents = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var self = this;
        if (!self._childComponentRef)
            return;
        if (self.eventNamesToSubscribe) {
            /** @type {?} */
            var outputs = self.eventNamesToSubscribe;
            this.clearComponentEventSubscriptions();
            outputs.forEach((/**
             * @param {?} eventName
             * @return {?}
             */
            function (eventName) {
                /** @type {?} */
                var subscription = self._childComponentRef.instance[eventName].subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    self.onCallbackFromComponent.call(self, eventName, data);
                }));
                if (_this._subscriptionRef.indexOf(subscription) === -1) {
                    _this._subscriptionRef.push(subscription);
                }
            }));
        }
    };
    /**
     * @return {?}
     */
    AngularComponentRenderingManager.prototype.onDestroy = /**
     * @return {?}
     */
    function () {
        this.clearComponentEventSubscriptions();
        this.renderingContainer.clear();
        _super.prototype.onDestroy.call(this);
    };
    return AngularComponentRenderingManager;
}(ComponentRenderingManager));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fxp-shared-component-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FxpSharedComponentLoader = /** @class */ (function () {
    function FxpSharedComponentLoader() {
        this.oncallback = new EventEmitter();
        if (!window["Fxp"] ||
            !window["Fxp"].Services ||
            !window["Fxp"].Services.PartnerAppRegistrationService ||
            !window["FxpAppSettings"]) {
            throw new Error("Failed to load Shared Component. It seems this this not running in context of FxP Platform");
        }
        console.log("SharedComponentLoader Initialized. ID: " + Math.random());
        this._partnerAppRegistrationService =
            window["Fxp"].Services.PartnerAppRegistrationService;
        this._fxpAppSettings = window["FxpAppSettings"];
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (!this._componentRenderingManager) {
            this.renderComponent();
            return;
        }
        if (this._componentRenderingManager.onComponentInputChange) {
            if (this.componentinputs) {
                this._componentRenderingManager.inputParameters = this.getInputParams(this.componentinputs);
            }
            if (this.getcallbacks) {
                this._componentRenderingManager.eventNamesToSubscribe = this.getOutputParams(this.getcallbacks);
            }
            this._componentRenderingManager.onComponentInputChange();
            this.broadcastEvent(SharedComponentLoaderCustomEvents.SharedComponentLoaderUpdated);
        }
        this.updateFeedbackParameters();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.onCallbackFromComponent = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.oncallback.emit(data);
        this.broadcastEvent(SharedComponentLoaderCustomEvents.SharedComponentCallBackInvoked);
    };
    /**
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.clearControls();
        this.broadcastEvent(SharedComponentLoaderCustomEvents.SharedComponentOnDestroyInvoked);
    };
    /**
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.clearControls = /**
     * @return {?}
     */
    function () {
        if (this._componentRenderingManager &&
            this._componentRenderingManager.onDestroy) {
            this._componentRenderingManager.onDestroy();
        }
        if (this.feedbackComponent) {
            this.feedbackComponent.clear();
        }
        if (this._feedbackCompRef) {
            this._feedbackCompRef.destroy();
        }
    };
    /**
     * @private
     * @param {?} factory
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.getComponentRenderingManager = /**
     * @private
     * @param {?} factory
     * @return {?}
     */
    function (factory) {
        if (factory.componentFramework &&
            factory.componentFramework.toString().toLowerCase() === "react") {
            return new ReactComponentRenderingManager(this.getInputParams(this.componentinputs), this.getOutputParams(this.getcallbacks), this.reactContainer, factory.component, this.onCallbackFromComponent.bind(this));
        }
        else {
            return new AngularComponentRenderingManager(this.getInputParams(this.componentinputs), this.getOutputParams(this.getcallbacks), this.angularContainer, factory.component, this.onCallbackFromComponent.bind(this));
        }
    };
    /**
     * @private
     * @param {?} parameters
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.getInputParams = /**
     * @private
     * @param {?} parameters
     * @return {?}
     */
    function (parameters) {
        if (!parameters)
            return [];
        if (typeof parameters === "string" || parameters instanceof String) {
            return JSON.parse(parameters.toString());
        }
        if (Array.isArray(parameters) || parameters.constructor === Object)
            return parameters;
        return [];
    };
    /**
     * @private
     * @param {?} parameters
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.getOutputParams = /**
     * @private
     * @param {?} parameters
     * @return {?}
     */
    function (parameters) {
        if (!parameters)
            return [];
        if (typeof parameters === "string" || parameters instanceof String) {
            return parameters.toString().split(",");
        }
        if (Array.isArray(parameters) || parameters.constructor === Object)
            return parameters;
        return [];
    };
    /**
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.renderComponent();
    };
    /**
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.renderComponent = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.appname || this.appname.length === 0) {
            console.error("%cError occured while loading SharedComponent. Mandatory parameter <appName> is missing. ", "font-size:15px");
            return;
        }
        if (!this.componentname || this.componentname.length === 0) {
            console.error("Mandatory parameter componentname is missing for the shared component.", "font-size:15px");
            return;
        }
        if (!this._componentRenderingManager && !this._fetchComponentReferencePromise) {
            this._fetchComponentReferencePromise = this._partnerAppRegistrationService.getSharedComponentReference(this.appname, this.componentname).then((/**
             * @param {?} sharedComponentReference
             * @return {?}
             */
            function (sharedComponentReference) {
                _this.clearControls();
                _this._componentRenderingManager =
                    _this.getComponentRenderingManager(sharedComponentReference);
                _this._componentRenderingManager.renderComponent();
                _this.renderFeedbackComponent();
                _this.broadcastEvent(SharedComponentLoaderCustomEvents.SharedComponentLoadComplete);
                _this._fetchComponentReferencePromise = null;
            }));
        }
    };
    /**
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.renderFeedbackComponent = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var self = this;
        self.feedbackComponent.clear();
        if (self.feedbackenabled && !self._fetchFeedbackComponentReferencePromise) {
            self._fetchFeedbackComponentReferencePromise = self._partnerAppRegistrationService
                .getSharedComponentFactory(self._fxpAppSettings.FeedbackControlPartnerName, self._fxpAppSettings.FeedbackControlComponentName).
                then((/**
             * @param {?} feedbackFactory
             * @return {?}
             */
            function (feedbackFactory) {
                self._feedbackCompRef = self.feedbackComponent.createComponent(feedbackFactory);
                self.updateFeedbackParameters();
                self._fetchFeedbackComponentReferencePromise = null;
            }));
        }
    };
    /**
     * @private
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.updateFeedbackParameters = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this._feedbackCompRef)
            return;
        if (this.feedbacksurveyid) {
            this._feedbackCompRef.instance['surveyID'] = this.feedbacksurveyid;
        }
        if (this.componentname) {
            this._feedbackCompRef.instance['sourceComponentName'] = this.componentname;
        }
        if (this.appname) {
            this._feedbackCompRef.instance['sourceAppName'] = this.appname;
        }
    };
    /**
     * @param {?} eventName
     * @param {?=} payload
     * @return {?}
     */
    FxpSharedComponentLoader.prototype.broadcastEvent = /**
     * @param {?} eventName
     * @param {?=} payload
     * @return {?}
     */
    function (eventName, payload) {
        if (payload === void 0) { payload = null; }
        if (payload === null) {
            payload = {};
        }
        payload.appName = this.appname || "";
        payload.componentName = this.componentname || "";
        payload.componentInputs = this.componentinputs || "";
        payload.getCallbacks = this.getcallbacks || "";
        /** @type {?} */
        var event = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            detail: payload,
        });
        window.dispatchEvent(event);
        console.log("EventName: " + eventName);
    };
    FxpSharedComponentLoader.decorators = [
        { type: Component, args: [{
                    selector: "fxp-shared-component-control-selector",
                    template: "<div>\r\n    <template #feedbackComponent></template>\r\n    <template #angularContainer></template>\r\n    <div #reactContainer></div>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    FxpSharedComponentLoader.ctorParameters = function () { return []; };
    FxpSharedComponentLoader.propDecorators = {
        appname: [{ type: Input }],
        componentname: [{ type: Input }],
        componentinputs: [{ type: Input }],
        getcallbacks: [{ type: Input }],
        feedbackenabled: [{ type: Input }],
        feedbacksurveyid: [{ type: Input }],
        oncallback: [{ type: Output }],
        angularContainer: [{ type: ViewChild, args: ["angularContainer", {
                        read: ViewContainerRef,
                        static: false,
                    },] }],
        reactContainer: [{ type: ViewChild, args: ["reactContainer", {
                        read: ElementRef,
                        static: false,
                    },] }],
        feedbackComponent: [{ type: ViewChild, args: ['feedbackComponent', {
                        read: ViewContainerRef,
                        static: false
                    },] }]
    };
    return FxpSharedComponentLoader;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/fxpsharedcomponentloader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FxpsharedcomponentloaderModule = /** @class */ (function () {
    function FxpsharedcomponentloaderModule() {
    }
    FxpsharedcomponentloaderModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [FxpSharedComponentLoader],
                    imports: [],
                    entryComponents: [FxpSharedComponentLoader],
                    exports: [FxpSharedComponentLoader]
                },] }
    ];
    return FxpsharedcomponentloaderModule;
}());

export { AngularComponentRenderingManager, ComponentRenderingManager, FxpSharedComponentLoader, FxpsharedcomponentloaderModule, ReactComponentRenderingManager, SharedComponentLoaderCustomEvents };
//# sourceMappingURL=fxp-fxpsharedcomponentloader.js.map
